import { ViewportScroller } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { hideSpinner, showSpinner } from "src/app/core/services/functions.service";
import { NotificationHelper } from "src/app/core/services/helpers/notification.helper";
import { AcuerdoPagoService } from "../services/acuerdo-pago.service";

@Component({
    selector: 'app-acuerdo-pago',
    templateUrl: './acuerdo-pago.component.html',
    styleUrls: ['./acuerdo-pago.component.scss']
})
export class AcuerdoPagoComponent implements OnInit {
    public form = this.formBuilder.group({
        n_ide: ["75566681", [Validators.required]],
        cue: ["3089", [Validators.required]],
    })

    public formAcuerdo = this.formBuilder.group({
        acuerdo: ["", [Validators.required]],
        saldo_ini: [, [Validators.required]],
    })

    columnsInfoCuenta: any[] = [
        { name: 'nom', value: 'CLIENTE' },
        { name: 'saldo_ven', value: 'SALDO VENCIDO' },
        { name: 'cuotas', value: '# CUOTAS' },
        { name: 'capital_total', value: 'CAPITAL' },
    ];

    displayedColumnsInfoCuenta: string[] = this.columnsInfoCuenta.map(value => { return value.name })
    dataInfoCuenta: any[] = [{}];

    dsInfoCuenta = new MatTableDataSource<Set<any>>(this.dataInfoCuenta);

    columnsPlan: any[] = [
        { name: 'cuota', value: 'CUOTA' },
        { name: 'fecha_v', value: 'FECHA VENCIMIENTO' },
        { name: 'v_cuota', value: 'VALOR CUOTA' },
        { name: 'est', value: 'ESTADO' }
    ];

    displayedColumnsPlan: string[] = this.columnsPlan.map(value => { return value.name })
    dataPlan: any[] = [
        { cuota: '1', fecha_v: '17/03/2022', v_cuota: '300', est: 'A' },
        { cuota: '2', fecha_v: '17/04/2022', v_cuota: '300', est: 'A' },
        { cuota: '3', fecha_v: '17/05/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
        { cuota: '4', fecha_v: '17/06/2022', v_cuota: '300', est: 'A' },
    ];

    dsPlan = new MatTableDataSource<Set<any>>(this.dataPlan);

    columnsSimu: any[] = [
        { name: 'plazo', value: 'PLAZO' },
        { name: 'capital', value: 'CAPITAL' },
        { name: 'interes', value: 'INTERES' },
        { name: 'seguro', value: 'SEGURO' },
        { name: 'tea', value: 'TEA' },
        { name: 'cuota_ini', value: 'CUOTA INICIAL'},
        { name: 'precio_full', value: 'PRECIO FULL' },
        { name: 'btn_acciones', value: 'ACCIONES' },

    ];

    displayedColumnsSimu: string[] = this.columnsSimu.map(value => { return value.name })
    dataSimu: any[] = [
        { plazo: '6', capital: '2220', interes: '1934,4', seguro: '0.0', tea: '4.00%', precio_full: '4.439,13' },

    ];

    dsSimu = new MatTableDataSource<Set<any>>(this.dataSimu);

    step = 1;

    plazos: any[] = [];

    constructor(private formBuilder: FormBuilder, private acuerdoPagoService: AcuerdoPagoService, private notificationHelper: NotificationHelper,) { }
    async ngOnInit(): Promise<void> {
        await this.getPlazos();
    }

    modStep(valor:number){
        this.step = valor;
    }

    async getPlazos() {
        showSpinner("Cargando parametros");
        const result = await this.acuerdoPagoService.getPlazos(0, 12);
        hideSpinner();
        if (result.success) {
            this.plazos = result.data;
        }else {
            this.notificationHelper.warningMessage("No hubo resultados en la consulta.")
        }
    }

    async buscar() {
        const formValues = this.form.value
        

        if (!this.form.get("n_ide")?.valid) { return this.notificationHelper.warningMessage("Ingrese el No. de identificación") }
        if (!this.form.get("cue")?.valid) { return this.notificationHelper.warningMessage("Ingrese el No. de cuenta") }


        showSpinner("Buscando cuenta");
        const result = await this.acuerdoPagoService.buscarCuenta(formValues.n_ide, formValues.cue);
        hideSpinner();
        if (result.success) {
            result.data.map(m => {
                m.saldo_ven = Number(m.saldo_ven);
                m.capital_total = Number(m.capital_total);
                m.cuotas = Number(m.cuotas);
                return m;
            })
            
            
            this.dataInfoCuenta = result.data;
            this.dsInfoCuenta = new MatTableDataSource<Set<any>>(this.dataInfoCuenta);
            this.formAcuerdo.get("saldo_ini")?.setValue(Number(this.dataInfoCuenta[0].saldo_ini_venc));
            this.step = 2;
            await this.moverScroll("target2");
        } else {
            this.step = 1;
            this.notificationHelper.warningMessage("No hubo resultados en la consulta.")
        }
    }

    async simularAcuerdo(){
        const formValues = this.formAcuerdo.value
        if (!this.formAcuerdo.get("saldo_ini")?.valid) { return this.notificationHelper.warningMessage("Ingrese el Saldo Inicial") }

        this.dataSimu = [];
        this.dataSimu.push(
            { plazo: formValues.acuerdo, capital: '2220', interes: '1934,4', seguro: '0.0', tea: '4.00%', precio_full: '4.439,13' },
        )
        this.dsSimu = new MatTableDataSource<Set<any>>(this.dataSimu);
        this.step = 3;
        await this.moverScroll("target3");
    }

    async aplicarAcuerdo() {
        this.step = 4;
        await this.moverScroll("target4");
    }

    async nuevaConsulta() {
        await this.moverScroll("target1");
        this.step = 1;
    }

    async moverScroll(tag: string) {
        setTimeout(function () {
            const docu = document.getElementById(tag);
            if (docu) {
                docu.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest"
                });
            }
        }, 200);
    }
}